import { useMemo, useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { LANGUAGES } from '@/lib/i18n';

function getSavedLanguage() {
  if (typeof window === 'undefined') return 'en';
  return window.localStorage.getItem('flyback_ui_lang') || 'en';
}

export default function LanguageToggle({ className = '' }) {
  const [active, setActive] = useState(getSavedLanguage);

  const ordered = useMemo(() => {
    const fallback = LANGUAGES[0]?.code || 'en';
    const activeCode = LANGUAGES.some((l) => l.code === active) ? active : fallback;
    return LANGUAGES.map((item) => ({ ...item, active: item.code === activeCode }));
  }, [active]);

  const pickLanguage = (code) => {
    setActive(code);
    if (typeof window !== 'undefined') {
      window.localStorage.setItem('flyback_ui_lang', code);
      window.dispatchEvent(new CustomEvent('flyback-language-change', { detail: { code } }));
    }
  };

  return (
    <div className={`relative rounded-xl border border-stone-200 bg-white/95 px-2 py-1 shadow-sm ${className}`}>
      <select
        value={active}
        onChange={(e) => pickLanguage(e.target.value)}
        className="h-7 pr-6 text-[11px] font-semibold text-stone-700 bg-transparent outline-none"
        data-testid="lang-toggle-dropdown"
      >
        {ordered.map((lang) => (
          <option key={lang.code} value={lang.code}>
            {lang.label}
          </option>
        ))}
      </select>
      <ChevronDown className="pointer-events-none absolute right-2 top-1/2 -translate-y-1/2 w-3.5 h-3.5 text-stone-500" />
    </div>
  );
}
